import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from '@/entities/auth';

import { clearDemoAuthSession, IS_DEMO_APP_MODE, logoutFromKeycloak } from '@/features/auth/lib';

export const useDirectAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clearAuth = useAuthStore((s) => s.clearAuth);

  const logout = () => {
    if (IS_DEMO_APP_MODE) {
      clearDemoAuthSession();
      clearAuth();
      queryClient.clear();
      void navigate('/login', { replace: true });
      return;
    }

    try {
      logoutFromKeycloak();
    } catch (error) {
      console.error('로그아웃 실패:', error);
      window.location.href = '/';
    }
  };

  return {
    logout,
  };
};
